import { getAppData } from '../../lib/api/common';
import { getUpdatesPage } from '../../lib/api/singles';
import { getEvents } from '../../lib/api/events';
import { getNews } from '../../lib/api/news';
import { getDeals } from '../../lib/api/deals';
import { getPodcastsIndexPages } from '../../lib/api/podcasts';
import { getOfferings } from '../../lib/api/offerings';

import Layout from '../../components/layout/Layout';
import SeoMaticHead from '../../components/common/SeoMaticHead'
import LatestNews from '../../components/content/pageBuilderBlocks/LatestNews';
import EventsList from '../../components/content/EventsList';
import DealsList from '../../components/content/DealsList';
import SectionDivider from '../../components/content/pageBuilderBlocks/SectionDivider';
import OfferingsList from '../../components/content/OfferingsList';
import PodcastsPagesList from '../../components/content/PodcastsPagesList';
import PageHeader from '../../components/content/page/PageHeader';
import { revalidateSeconds } from "../../lib/helpers/revalidateSeconds";
import { ECMOffering } from '../../lib/enums/offerings'

export type UpdatesProps = {
	page: any
	news: Array<any>
	events: Array<any>
	deals: Array<any>
	podcastsPages: Array<any>
	offerings: Array<any>
	app: any
}

export async function getStaticProps(context: any) {

	const app: any = await getAppData();
	const page: any = await getUpdatesPage(
		context.preview ? context.previewData?.token : undefined
	);
	const events: any = await getEvents(6);
	const news: any = await getNews(6);
	const deals: any = await getDeals();
	const podcastsPages: any = await getPodcastsIndexPages();
	const offerings: any = await getOfferings(ECMOffering.section, ECMOffering.entry, 3);

	return {
		props: {
			app: app ? app : null,
			page: page?.entry ? page.entry : null,
			news: news?.entries ? news.entries : null,
			events: events?.entries ? events.entries : null,
			deals: deals?.entries ? deals.entries : null,
			podcastsPages: podcastsPages?.entries ? podcastsPages.entries : null,
			offerings: offerings?.entries ? offerings.entries : null,
		},
		revalidate: revalidateSeconds()
	};
}

export default function Updates(props: UpdatesProps) {
	const { page, news, events, deals, podcastsPages, offerings, app } = props

	const featuredDeals = deals.filter(deal => deal.featured === true );
	const latestDeals = deals.slice(0, 3);

	return (
		<>
			<SeoMaticHead seo={page.seo} />
			<Layout
				appData={app}
				subHeader={[
					{
						id: page.id,
						title: page.title,
						uri: null
					}
				]}
			>
				<>

					<PageHeader page={page} />
					<DealsList
						deals={latestDeals}
						featuredDeals={featuredDeals}
						heading={`Transactions & Deals`}
						link={true}
					/>

					{news && news.length > 0 ? (
						<>
							<SectionDivider />
							<LatestNews
								heading={`Latest news`}
								addArchiveLink={true}
								news={news}
							/>
						</>
					) : null}

					{offerings && offerings.length > 0 ? (
						<>
							<SectionDivider />
							<OfferingsList
								heading={`Offerings`}
								offerings={offerings}
								addArchiveLink={true}
								link={true}
							/>
						</>
					) : null}

					{events && events.length > 0 ? (
						<>
							<SectionDivider />
							<EventsList
								heading={`Upcoming events`}
								addArchiveLink={true}
								events={events}
							/>
						</>
					) : null}

					{podcastsPages && podcastsPages.length > 0 ? (
						<>
							<SectionDivider />
							<PodcastsPagesList
								heading={`Podcasts`}
								addArchiveLink={true}
								podcastsPages={podcastsPages}
							/>
						</>
					) : null}

				</>
			</Layout>
		</>
	)
}
